import styled from 'styled-components';

/**
 * 기존 SearchBox 카드형 외곽과 같은 톤 — 흰 배경 + 얇은 경계.
 */
export const StyledFilterCard = styled.div`
  padding: 15px 20px;
  background-color: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
`;

export const StyledFilterRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 12px;
`;

export const StyledLabel = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: #4b5563;
  white-space: nowrap;
`;

/** 뷰 토글 + 등록 버튼을 오른쪽 끝으로 밀어낸다. */
export const StyledRightGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
`;
